module.exports = "<div class=\"main\">\n  <navbar></navbar>\n  <div ui-view></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/main/main.html
// module id = 468
// module chunks = 0